/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */

import React from 'react';
import { Map } from 'immutable';
import classNames from 'classnames';
import { DropdownSelect, type SingleValue } from 'src/components/DropdownWrapper/DropdownWrapper';
import { ScrollBubblingMenuList } from 'src/components/DropdownWrapper/ScrollBubblingMenuList';

import { money } from 'src/utils/format';
import symbols from 'src/config';
import getErrorMessage, { mapErrors, listMappedErrors } from './errors';

interface EmptyBetPropsType {
    selections: Map<string, any>; //type needs to be defined
    legs: Map<string, any>; //type needs to be defined
    bet: Map<string, any>; //type needs to be defined
    currency: Map<string, any>; //type needs to be defined
    assignedToMe?: boolean;
    marketTemplates: Map<string, any>; //type needs to be defined
    sports: Map<string, any>; //type needs to be defined
    focusedBet: Map<string, any> | null; //type needs to be defined
    selected?: boolean;
    onSelect?: () => void;
    onUnselect?: () => void;
    onLegChange?: (legId: string, changes: any) => void; //type needs to be defined
    onChange?: (changes: any) => void; //type needs to be defined
    onRemove?: () => void;
    onGetMarketTemplatesList?: (sport: string) => void; //type needs to be defined
}

interface EmptyBetStateType {
    stakePerLine: number | string;
    price: number | string;
    eventName: string;
    selectionName: string;
    sport: string;
    marketType: string;
}

export class EmptyBet extends React.Component<EmptyBetPropsType, EmptyBetStateType> {
    public static defaultProps = {
        focusedBet: null,
        selected: false,
        selections: Map(),
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        onSelect: () => {},
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        onUnselect: () => {},
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        onLegChange: () => {},
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        onRemove: () => {},
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        onChange: () => {},
    };

    public constructor(props: EmptyBetPropsType) {
        super(props);
        this.state = this.getState(props);
    }

    public componentDidUpdate(prevProps: EmptyBetPropsType): void {
        const leg = this.props.legs.get(this.props.bet.getIn(['legs', 0]));
        const prevLeg = prevProps.legs.get(prevProps.bet.getIn(['legs', 0]));

        if (
            this.props.bet.get('stakePerLine') !== prevProps.bet.get('stakePerLine') ||
            (leg &&
                prevLeg &&
                (leg.getIn(['price', 'd']) !== prevLeg.getIn(['price', 'd']) ||
                    leg.get('price') !== prevLeg.get('price') ||
                    leg.get('eventName') !== prevLeg.get('eventName') ||
                    leg.get('selectionName') !== prevLeg.get('selectionName') ||
                    leg.get('sport') !== prevLeg.get('sport') ||
                    leg.get('marketType') !== prevLeg.get('marketType')))
        ) {
            this.setState(this.getState(this.props));
        }
    }

    public getState(props: EmptyBetPropsType, values?: Partial<EmptyBetStateType>): EmptyBetStateType {
        const leg = props.legs.get(props.bet.getIn(['legs', 0]));

        const defaultState = {
            stakePerLine: 0,
            price: 0,
            eventName: '',
            selectionName: '',
            sport: '',
            marketType: '',
        };

        return Object.assign(
            {},
            defaultState,
            {
                stakePerLine:
                    this.state &&
                    (props.bet.get('stakePerLine') === 0 || props.bet.get('stakePerLine') !== this.state.stakePerLine)
                        ? this.state.stakePerLine
                        : props.bet.get('stakePerLine'),
                price: (this.state && this.state.price) || leg?.getIn(['price', 'd']) || leg?.get('price') || 0,
                eventName: (this.state && this.state.eventName) || leg?.get('eventName') || '',
                selectionName: (this.state && this.state.selectionName) || leg?.get('selectionName') || '',
                sport: (this.state && this.state.sport) || leg?.get('sport') || '',
                marketType: (this.state && this.state.marketType) || leg?.get('marketType') || '',
            },
            values
        );
    }

    public toggle = (): void => {
        if (this.props.selected === true) {
            this.props.onUnselect?.();
        } else {
            this.props.onSelect?.();
        }
    };

    public toggleValue = (id: string): void => {
        const bet = this.props.bet.toJS();
        bet[id] = !bet[id];
        this.props.onChange?.(bet);
    };

    public toggleSP = (): void => {
        const legId = this.props.bet.getIn(['legs', 0]);
        const leg = this.props.legs.get(legId) || Map();
        const priceType = leg.get('priceType') === 'sp' ? 'fp' : 'sp';
        this.props.onLegChange?.(legId, { priceType });
    };

    public remove = (e: React.MouseEvent<HTMLAnchorElement>): void => {
        e.preventDefault();
        this.props.onRemove?.();
    };

    public updateStake = (stakePerLine: string): void => {
        this.setState({ stakePerLine });
    };

    public updateLeg = (property: keyof EmptyBetStateType, value: string): void => {
        this.setState((prevState) => ({
            ...prevState,
            [property]: value,
        }));
    };

    public getStake(): number {
        const { bet } = this.props;
        let stake = parseFloat(String(this.state?.stakePerLine));

        if (isNaN(stake)) {
            stake = bet.get('stakePerLine') || 0;
        }

        return stake;
    }

    public saveStake = (): void => {
        const { bet } = this.props;
        const stake = this.getStake();

        if (stake === (bet.get('stakePerLine') || 0)) {
            this.setState({
                stakePerLine: bet.get('stakePerLine') || 0,
            });
        } else {
            this.props.onChange?.({
                stakePerLine: stake,
            });
        }
    };

    public updatePrice = (price: string): void => {
        this.setState({ price });
    };

    public getPrice(): string {
        const { bet, legs } = this.props;
        let price = String(this.state?.price);

        if (price) {
            if (price.includes('/')) {
                const priceParts = (price || '0/1').split('/');
                const numerator = parseInt(priceParts[0] || '0', 10);
                const denominator = parseInt(priceParts[1] || '1', 10);

                if (isNaN(numerator) || isNaN(denominator)) {
                    price = legs.getIn([bet.getIn(['legs', 0]), 'price']) || '0/1';
                } else {
                    price = `${numerator}/${denominator}`;
                }

                if (price.slice(-2) === '/1' && price.split('/')[0] === String(this.state.price)) {
                    price = price.slice(0, price.length - 2);
                }
            }
        } else {
            return '0';
        }

        return price;
    }

    public savePrice = (): void => {
        const { bet, legs } = this.props;
        const leg = bet.getIn(['legs', 0]);
        let price: string | { d: number } = this.getPrice();
        const currentPrice = legs.getIn([leg, 'price']) || 0;

        if (price === currentPrice) {
            this.setState({ price: currentPrice });
        } else {
            if (!price.includes('/')) {
                price = { d: parseFloat(price) };
            }
            this.props.onLegChange?.(leg, { price });
        }
    };

    public saveLeg = (property: keyof EmptyBetStateType): void => {
        const legUid = this.props.bet.getIn(['legs', 0]);
        const leg = this.props.legs.get(legUid);
        const value = this.state[property];

        if (value !== leg?.get(property)) {
            this.props.onLegChange?.(legUid, { [property]: value });
        }
    };

    public cleanStake = (): void => {
        const { stakePerLine } = this.state;
        this.setState({
            ...this.state,
            stakePerLine: stakePerLine ? stakePerLine : '',
        });
    };

    public cleanPrice = (): void => {
        const { price } = this.state;
        this.setState({
            ...this.state,
            price: price ? price : '',
        });
    };

    public getPossibleReturns(): number {
        const { bet } = this.props;
        const priceParts = String(this.getPrice()).split('/');
        const numerator = parseInt(priceParts[0] || '0', 10);
        const denominator = parseInt(priceParts[1] || '1', 10);

        return Math.round(Math.round(100 * bet.get('stakePerLine')) * (numerator + denominator)) / denominator;
    }

    //@ts-expect-error
    public prepareData = (data): any[] => {
        const other = {
            id: 'other',
            marketName: 'Other',
            name: 'Other',
        };

        if (data && data.size) {
            const list = data
                .toList()
                //@ts-expect-error
                .sortBy((x) => x.get('name') || x.get('marketName'))
                .toArray()
                //@ts-expect-error
                .map((item) => (item.toJS ? item.toJS() : item));
            return [...list, other];
        }

        return [other];
    };

    public onSelectChange = (key: keyof EmptyBetStateType, value: string): void => {
        if (value) {
            this.updateLeg(key, value);
        }

        if (key === 'sport' && value) {
            this.props.onGetMarketTemplatesList?.(value);
            this.updateLeg('marketType', '');
        }
    };

    public render(): JSX.Element {
        const { legs, bet, focusedBet, selected, currency, assignedToMe, sports, marketTemplates } = this.props;
        const { sport, marketType } = this.state;
        //@ts-expect-error
        const currencySymbol = symbols.symbols[currency.get('value')] || '';
        const sportMarketTemplates =
            sport && marketTemplates.size ? marketTemplates.filter((x) => x.getIn(['sport', 'id']) === sport) : Map();

        const stakeLink = {
            value: this.state.stakePerLine,
            requestChange: this.updateStake,
        };

        const priceLink = {
            value: this.state.price,
            requestChange: this.updatePrice,
        };

        const eventLink = {
            value: this.state.eventName,
            requestChange: (value: string) => this.updateLeg('eventName', value),
        };

        const selectionLink = {
            value: this.state.selectionName,
            requestChange: (value: string) => this.updateLeg('selectionName', value),
        };

        const isSelectedLeg =
            focusedBet && bet.get('legs').size === 1 && focusedBet.get('legs').contains(bet.getIn(['legs', 0]));

        const isReferred = bet.get('isReferred');

        let errorsEl: string | undefined;
        if (bet.get('errors') && bet.get('errors').size) {
            const errors = mapErrors(bet.get('errors'));

            errorsEl = listMappedErrors(errors, {
                'SelectedBet:not-found': (details: { get: (arg0: string) => string }) => {
                    if (details.get('field') === 'eachWay') {
                        return "This selection doesn't allow each way terms.";
                    }
                    return getErrorMessage(details);
                },
            })
                //@ts-expect-error
                .map((error) => (error.constructor === String ? error : error.props.children))
                .join('\n');
        }

        const leg = legs.get(bet.getIn(['legs', 0])) || Map();
        const hasSP = leg.get('priceType') === 'sp';
        const possibleReturnsEstimated = !hasSP && bet.get('potentialReturnsAt') !== Math.round(this.getStake() * 100);
        const possibleReturns = hasSP
            ? null
            : possibleReturnsEstimated
              ? this.getPossibleReturns()
              : bet.get('potentialReturns');

        const clsName = classNames([
            'betslip-leg--empty',
            {
                'betslip-leg--marked': isSelectedLeg,
                'betslip-leg--error': bet.get('errors') && bet.get('errors').size,
                'is-sp': hasSP,
            },
        ]);

        return (
            <li className={clsName}>
                {assignedToMe || !isReferred ? (
                    <a
                        href='#'
                        className='betslip-leg-remove'
                        onClick={this.remove}
                    >
                        &times;
                    </a>
                ) : null}

                <span className='betslip-leg-name'>
                    <input
                        type='checkbox'
                        value='1'
                        onChange={this.toggle}
                        checked={selected}
                    />

                    <label htmlFor='eventName'>Event</label>
                    <div className='element'>
                        <input
                            type='text'
                            value={eventLink.value}
                            onChange={(e) => eventLink.requestChange(e.target.value)}
                            placeholder='Event name'
                            onBlur={() => this.saveLeg('eventName')}
                        />
                    </div>

                    <label htmlFor='selectionName'>Selection</label>
                    <div className='element'>
                        <input
                            type='text'
                            value={selectionLink.value}
                            onChange={(e) => selectionLink.requestChange(e.target.value)}
                            placeholder='Selection name'
                            onBlur={() => this.saveLeg('selectionName')}
                        />
                    </div>
                </span>

                <div className='betslip-leg-sport'>
                    <div className='row'>
                        <label htmlFor='sportName'>Sport</label>
                        <div className='element'>
                            <DropdownSelect<{ id: string; marketName: string; name: string }, false>
                                options={this.prepareData(sports)}
                                onChange={(option: SingleValue<{ id: string; marketName: string; name: string }>) => {
                                    if (option) {
                                        this.onSelectChange('sport', option.id || option.name);
                                    }
                                }}
                                onBlur={() => this.saveLeg('sport')}
                                value={this.prepareData(sports).find((opt) => opt.id === sport) || null}
                                placeholder='Select sport'
                                getOptionValue={(option) => option.id}
                                getOptionLabel={(option) => option.marketName || option.name}
                                hasInternalLabel={false}
                                closeMenuOnScroll={false}
                                components={{
                                    MenuList: ScrollBubblingMenuList,
                                }}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <label htmlFor='marketType'>Market Type</label>
                        <div className='element'>
                            <DropdownSelect<{ id: string; marketName: string; name: string }, false>
                                options={this.prepareData(sportMarketTemplates)}
                                onChange={(option: SingleValue<{ id: string; marketName: string; name: string }>) => {
                                    if (option) {
                                        this.onSelectChange('marketType', option.marketName);
                                    }
                                }}
                                onBlur={() => this.saveLeg('marketType')}
                                value={
                                    this.prepareData(sportMarketTemplates).find(
                                        (opt) => opt.marketName === marketType
                                    ) || null
                                }
                                placeholder='Select market type'
                                isDisabled={!sport}
                                getOptionValue={(option) => option.marketName}
                                getOptionLabel={(option) => option.marketName || option.name}
                                hasInternalLabel={false}
                                closeMenuOnScroll={false}
                                components={{
                                    MenuList: ScrollBubblingMenuList,
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className='betslip-leg-amount empty'>
                    <div
                        className='row'
                        title={errorsEl}
                    >
                        <div className='col-5'>
                            <div className={classNames(['element', { 'bet-red-border': errorsEl }])}>
                                <input
                                    type='text'
                                    style={errorsEl ? { color: 'red' } : undefined}
                                    value={priceLink.value}
                                    onChange={(e) => priceLink.requestChange(e.target.value)}
                                    onBlur={this.savePrice}
                                    onClick={this.cleanPrice}
                                />
                            </div>
                        </div>
                        <div className='col-7'>
                            <div className='element'>
                                <span className='prefix'>{currencySymbol}</span>
                                <input
                                    type='text'
                                    value={stakeLink.value}
                                    onChange={(e) => stakeLink.requestChange(e.target.value)}
                                    onBlur={this.saveStake}
                                    onClick={this.cleanStake}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className='betslip-leg-options'>
                    <label className='checkbox'>
                        <input
                            type='checkbox'
                            checked={bet.get('eachWay')}
                            onChange={() => this.toggleValue('eachWay')}
                        />{' '}
                        EW
                    </label>
                    <label className='checkbox'>
                        <input
                            type='checkbox'
                            checked={leg.get('priceType') === 'sp'}
                            onChange={this.toggleSP}
                        />{' '}
                        SP
                    </label>
                </div>

                <div
                    className={classNames([
                        'betslip-leg-returns',
                        { 'betslip-leg-returns--estimated': possibleReturnsEstimated },
                    ])}
                >
                    {possibleReturns ? (
                        <div>
                            Possible returns: {currencySymbol}
                            {money(possibleReturns, currency)}
                        </div>
                    ) : undefined}
                </div>
            </li>
        );
    }
}
